import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "win-tab-bar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_win_action_menu = _resolveComponent("win-action-menu");
  const _component_tab_bar = _resolveComponent("tab-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_tab_bar, {
    ref: "viewTabBarRef",
    items: $setup.tabItems,
    "active-key": $setup.activeWinKeyRef,
    onChanged: $setup.handleTabChanged,
    onCloseTab: $setup.handleCloseTab
  }, {
    rightExtra: _withCtx(() => [_createVNode(_component_win_action_menu, {
      items: $setup.tabItems,
      "active-key": $setup.activeWinKeyRef,
      onMenuClick: $setup.handleTabMenuClick,
      onWinMenuClick: $setup.handleWinMenuClick
    }, null, 8, ["items", "active-key", "onMenuClick", "onWinMenuClick"])]),
    _: 1
  }, 8, ["items", "active-key", "onChanged", "onCloseTab"])]);
}